import { render } from "./AgePicker.vue?vue&type=template&id=dd1db0c2&ts=true"
import script from "./AgePicker.vue?vue&type=script&lang=ts"
export * from "./AgePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__